import {
  Button,
  FormInput,
  FormRoot,
  FormSelect,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import type {
  VehicleModelCreateInput,
  VehicleModelUpdateInput,
} from "@/modules/catalog/domain/contracts";

const VehicleModelFormSchema = z.object({
  makeId: z.string().uuid("ກະລຸນາເລືອກຍີ່ຫໍ້"),
  name: z.string().min(1, "ກະລຸນາໃສ່ຊື່ຮຸ່ນ"),
});

type VehicleModelFormValues = z.infer<typeof VehicleModelFormSchema>;

type VehicleModelFormProps = {
  initialValues?: Partial<VehicleModelFormValues>;
  makeOptions: Array<{ value: string; label: string }>;
  onSubmit: (values: VehicleModelCreateInput | VehicleModelUpdateInput) => void;
  onCancel?: () => void;
  submitting?: boolean;
  submitLabel?: string;
};

export function VehicleModelForm({
  initialValues,
  makeOptions,
  onSubmit,
  onCancel,
  submitting,
  submitLabel = "ບັນທຶກ",
}: VehicleModelFormProps) {
  const methods = RHF.useForm<VehicleModelFormValues>({
    resolver: zodResolver(VehicleModelFormSchema),
    defaultValues: {
      makeId: initialValues?.makeId ?? makeOptions[0]?.value ?? "",
      name: initialValues?.name ?? "",
    },
  });

  return (
    <FormRoot<VehicleModelFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          makeId: vals.makeId,
          name: vals.name,
        })
      }
      className="space-y-4"
    >
      <FormSelect name="makeId" label="ຍີ່ຫໍ້" options={makeOptions} />
      <FormInput name="name" label="ຊື່ຮຸ່ນ" placeholder="ຕົວຢ່າງ: Vios" />
      <div className="flex justify-end gap-2 pt-2">
        {onCancel && (
          <Button type="button" variant="outline" onClick={onCancel}>
            ຍົກເລີກ
          </Button>
        )}
        <Button type="submit" disabled={submitting}>
          {submitLabel}
        </Button>
      </div>
    </FormRoot>
  );
}
